<template>
  <div>
    <div class="split__wrapper">
      <div v-if="!hideTitle && !hideButton" class="split__wrapper--title"><div class="title-left">Odkryj wyższy<br>Nowe</div><div class="title-right" >poziom gotowania<br>płyty 2.0</div></div>
      <img class="header_product_image" :src="component_data.bg_product_mobile"/>
         <img v-if="hideButton" class="scroll_icon" :src="component_data.icon_scroll"/>
     
      <div
        @mouseenter="mouseEnterLeft"
        @mouseleave="mouseLeave"
        class="left-content"
        @transitionend.self="setAnimation"
         
        :class="{
          showHalf: showHalf,
          active: showLeft,
          showZero: showZeroLeft,
          mouseActive:isMouseActiveLeft,
          mouseNotActive:!mouseNotActive
        }"
             >
        <div @click="expandLeftContent" class="left-content--link"></div>
        <button
          v-if="!hideButton"
          class="insideButton expand-left"
           @click="expandLeftContent"
     
        >
          płyty gazowe
        </button>
        <div
          class="assideButton"
          :class="{ right: showLeft }"
          @click="expandRightContent"
        >
          <span class="assideButton-text">płyty indukcyjne</span>
          <img class="left-direction" :src="component_data.icon_arrow"/>
        </div>
      </div>

      <div
        @mouseenter="mouseEnterRight"
        @mouseleave="mouseLeave"
        class="right-content"
        @transitionend.self="setAnimation"
        :class="{
          showHalf: showHalf,
          active: showRight,
          showZero: showZeroRight,
          mouseActive:isMouseActiveRight,
          mouseNotActive:mouseNotActive
          }"
      >
       <div @click="expandRightContent" class="right-content--link"></div>
        <button
          v-if="!hideButton"
          class="insideButton expand-right"
          @click="expandRightContent"
        >
          płyty indukcyjne
        </button>
        <div
          class="assideButton"
          :class="{ left: showRight }"
          @click="expandLeftContent"
        >
        <span class="assideButton-text">płyty gazowe</span>
        <img :src="component_data.icon_arrow"/>
       
      </div>
      </div>
    </div>
      <div class="mobile_button_wrapper">
        <button
          class="insideButton mobile-button"
          @click="expandLeftContent"
        >
          płyty gazowe
        </button>
        <button
          class="insideButton mobile-button"
          @click="expandRightContent"
        >
          płyty indukcyjne
        </button>
      </div>
      <div v-if="!hideButton" class="mobile_content_wrapper">
         <span class="mobile-title">Odkryj wyższy<br>poziom gotowania</span><span>Nowe płyty 2.0</span>
        
      </div>
      <template v-if="activeSection !== null">
        <transition-group name="fade" tag="div" appear>
          <mid
            v-for="(component, index) in component_data.splitContent[activeSection]"
            :key="index + 'activeSection' + activeSection"
            :component_data="component"
          ></mid>
        </transition-group >
      </template>

  </div>
</template>

<script>
export default {
  props: ["component_data"],
  data() {
    return {
      elo: this.component_data.bg_product_mobile,
      showRight: false,
      showLeft: false,
      hideButton: false,
      showZeroRight: false,
      showZeroLeft: false,
      showHalf: true,
      isMouseActiveLeft: false,
      isMouseActiveRight: false,
      activeSection: null,
      hideTitle: false,
      mouseNotActive: false,
    };
  },
  methods: {
    expandLeftContent() {
      this.showLeft = true;
      this.showRight = false;
      this.hideButton = true;
      this.showZeroLeft = false;
      this.isMouseActiveLeft = false;
      this.isMouseActiveRight = false;
      this.activeSection = 0;
      this.mouseNotActive = false;
    },

    expandRightContent() {
      this.showRight = true;
      this.showLeft = false;
      this.hideButton = true;
      this.showZeroRight = false;
      this.isMouseActiveLeft = false;
      this.isMouseActiveRight = false;
      this.activeSection = 1;
      console.log(this.component_data)
    },
    setAnimation() {
            if (this.hideButton) {
        this.showZeroRight = this.showLeft;
        this.showZeroLeft = this.showRight;
        this.showHalf = false;
      }
    },
    mouseEnterLeft() {
      if (!this.hideButton) {
        this.isMouseActiveLeft = true;
        this.hideTitle = true;
        this.mouseNotActive = false;
      }
    },
    mouseEnterRight() {
      if (!this.hideButton) {
        this.isMouseActiveRight = true;
        this.hideTitle = true;
        this.mouseNotActive = true;
      }
    },
    mouseLeave() {
      this.isMouseActiveRight = false;
      this.isMouseActiveLeft = false;
      this.hideTitle = false;
    },
  },
};
</script>

<style lang="scss">
/* Enter and leave animations can use different */
/* durations and timing functions.              */

.fade-enter-active {
  transition: ease 2.2s;
  transition-delay: 0.4s;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-active {
  transition: ease 0.4s;
}

.split__wrapper {
  position: relative;

  width: 100%;
  height: 37.5vw;
  overflow: hidden;
  z-index: 1100;
  @media (max-width: 786px) {
    height: 300px;
    background-image: url("../../assets/mobile_plyty_mix_header.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  &--title {
    position: absolute;
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 1101;
    top: 10px;
    font-family: "Uni Neue";
    font-size: 2.1vw;
    font-weight: 700;
    @media (max-width: 786px) {
      display: none;
    }
    .title-left {
      text-align: right;
      width: 50%;
      justify-content: flex-end;
      display: flex;
      padding-right: 5px;
      color: white;
    }
    .title-right {
      margin-left: 0rem;
      padding-left: 5px;
      width: 50%;
    }
  }
  .scroll_icon {
    position: absolute;
    bottom: 0.5vw;
    left: 50%;
    width: 1.24vw;
    z-index: 1100;
    transform: translate(-50%);
    .scroll_icon img {
      max-width: 100%;
      height: auto;
    }

    @media (max-width: 786px) {
      width: 13px;
    }
  }
  .header_product_image {
    display: none;
    position: absolute;
    left: 50%;
    top: 10%;
    height: 100%;
    z-index: 1100;
    transform: translate(-50%);

    @media (max-width: 786px) {
      display: flex;
    }
  }
}

.left-content {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  background-image: url("../../assets/gazowa_banner10.jpg");
  background-size: cover;
  transition: all 2.5s ease;
  @media screen and (max-width: 786px) {
    display: none;
  }
  &--link {
    width: 90%;
    height: 100%;
  }
}

.right-content {
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
  background-image: url("../../assets/indukcja_banner1.jpg");
  background-position: right;
  background-size: cover;
  transition: all 2.5s ease;
  @media screen and (max-width: 786px) {
    display: none;
  }
  &--link {
    width: 100%;
    height: 100%;
  }
}

.showHalf {
  width: 50%;
}

.active {
  // transition: all 2.5s ease;
  z-index: 3;
  width: 100%;
  // -moz-transition: all 2.5s ease;
}
@media (min-width: 991px) {
  .mouseActive {
    z-index: 3;
    width: 70%;
    transform: scale(1.05);
  }
  .mouseNotActive {
    z-index: 3;
  }
  .mouseNotActive1 {
    z-index: 5;
  }
}

.showZero {
  width: 0;
}

.assideButton {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 3%;
  background-color: #d21020;
  height: 100%;
  position: absolute;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: "Uni Neue";
  padding: 5px;
  img {
    margin-top: 10px;
  }
  .left-direction {
    transform: rotate(180deg);
  }
}

.right {
  opacity: 1;
  right: 0px;
  animation-name: slideIn;
  animation-duration: 2.5s;
  z-index: 10;
}

.left {
  opacity: 1;
  left: 0px;
  animation-name: slideIn;
  animation-duration: 2.5s;
  z-index: 10;
}

@keyframes slideIn {
  0% {
    opacity: 0;
  }

  15% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.assideButton-text {
  display: flex;
  width: 100%;
  text-transform: uppercase;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  align-items: center;
  letter-spacing: 2px;
  color: white;
  font-size: 1vw;
  @media (max-width: 1400px) {
    font-size: 12px;
  }
}
.insideButton {
  font-family: "Uni Neue";
  text-transform: uppercase;
  font-weight: 500;
  color: white;
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 12px 22px;
  letter-spacing: 0.07em;
  cursor: pointer;
  background: rgb(191, 13, 19);
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(227, 19, 41, 1)),
    to(rgba(191, 13, 19, 1))
  );
  background: linear-gradient(
    90deg,
    rgba(227, 19, 41, 1) 0%,
    rgba(191, 13, 19, 1) 100%
  );
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-box-shadow: 0 0 0 0px transparent;
  box-shadow: 0 0 0 0px transparent;
  font-size: 0.9vw;
  // display: inline-block;
  @media (max-width: 1400px) {
    font-size: 12px;
  }
}
.mobile_content_wrapper {
  display: none;
}
.mobile_content_wrapper {
  @media (max-width: 786px) {
    display: flex;
    justify-content: center;
    align-items: stretch;
    text-align: center;
    padding: 50px 0px;
    font-family: "Uni Neue";
    font-size: 22px;
    flex-direction: column;
    .mobile-title {
      font-weight: bold;
      font-size: 28px;
      margin-bottom: 1rem;
    }
  }
}

.mobile-button {
  display: none;
}

@media (max-width: 786px) {
  .mobile_button_wrapper {
    display: flex;
    width: 100%;
    background-color: blue;
    height: 60px;
    align-items: center;
    justify-content: center;
  }
  .mobile-button {
    height: 100%;
    display: inline-block;
    width: 50%;
    border-radius: 0;
    border: none;
    transition: width 0.35s ease-in-out;
  }
  .mobile-button:focus {
    width: 100%;
    -webkit-box-shadow: 0px 0px 25px 5px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 25px 5px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 25px 5px rgba(0, 0, 0, 0.75);
    z-index: 5;
  }
}

.expand-right {
  display: inline-block;
  position: absolute;
  bottom: 7%;
  right: 300px;
  @media (max-width: 1400px) {
    right: 200px;
  }
  @media (max-width: 1091px) {
    right: 100px;
  }
  @media (max-width: 768px) {
    display: none;
  }
}

.expand-left {
  display: inline-block;
  position: absolute;
  bottom: 7%;
  left: 300px;
  @media (max-width: 1400px) {
    left: 200px;
  }
  @media (max-width: 1091px) {
    left: 100px;
  }
  @media (max-width: 768px) {
    display: none;
  }
}
</style>
